import { useTranslation } from 'react-i18next';

const LANGS = [
  { code: 'es', label: 'ES' },
  { code: 'ru', label: 'RU' },
  { code: 'en', label: 'EN' },
];

export function LangSwitch() {
  const { i18n } = useTranslation();
  const current = i18n.resolvedLanguage ?? 'es';
  return (
    <div className="inline-flex items-center bg-surface-3 rounded-md p-0.5">
      {LANGS.map(l => (
        <button
          key={l.code}
          onClick={() => i18n.changeLanguage(l.code)}
          className={`px-2 py-0.5 text-[11px] font-medium rounded transition ${
            current === l.code ? 'bg-surface text-ink shadow-sm' : 'text-ink-3 hover:text-ink'
          }`}
        >{l.label}</button>
      ))}
    </div>
  );
}
